import { BaseElement } from './base-element';
import { ElementType } from './element-type';

export class Timeline extends BaseElement {
  timelineRows: TimelineRow[] = [];

  constructor() {
    super();
    this.elementType = ElementType.timeline;
  }
}

export class TimelineRow extends BaseElement {
  constructor() {
    super();
  }

  date: string | null = null;
  time: string | null = null;
  icon: string | null = null;
  iconStyle: string | null = null;
  value1: string | null = null;
  value2: string | null = null;
}
